var _path, _circle, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.52 15.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76 12.35s.26-.51 2.24-.93a26.48 26.48 0 003.36-1 6.41 6.41 0 00-1.31-1.22 8.94 8.94 0 00-3.34-1.13H8.83A9 9 0 005.49 9.2a6.17 6.17 0 00-1.3 1.22 25.78 25.78 0 003.35 1c1.96.42 2.22.93 2.22.93z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.76,
    cy: 3.63,
    r: 3.63
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93 15.86a2 2 0 00-1.32-1.54l-.87-.28a1.05 1.05 0 00-.24-.06h-.2a1.21 1.21 0 00-1.22 1.15l-.08.74zM19.52 15.86l-.08-.74a1.21 1.21 0 00-1.22-1.15h-.2a1.05 1.05 0 00-.24.06l-.87.28a2 2 0 00-1.31 1.54z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83 13.57a2.81 2.81 0 011.87 2.29h10.13a2.81 2.81 0 011.87-2.29l.87-.28a2.73 2.73 0 01.48-.1v-2.76l-.84.27-6.83 2.23H9.2L2.37 10.7l-.84-.27v2.76a2.73 2.73 0 01.48.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.342f04aa.svg";
export { ForwardRef as ReactComponent };